"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDialog = void 0;
var _openProductInfoDialog = require("@ori-events/open-product-info-dialog");
var _tsUtils = require("@ori/ts-utils");
var _react = require("react");
const useDialog = props => {
  const {
    atpClusterId,
    droppingId,
    isSubscriptionReplacementAllowed,
    itemCode,
    lineNumber,
    quantity,
    replacement,
    subscriptionId,
    subscriptionItemInfo,
    handleChangedLineNumber,
    setChangedLineNumber
  } = props;
  const isFlavorReplacementAvailable = (0, _react.useRef)(false);
  const replacementOffers = (0, _react.useMemo)(() => (0, _tsUtils.isNonNullable)(replacement) ? replacement.offers : undefined, [replacement]);
  const replacementItems = (0, _react.useMemo)(() => {
    const replacementItemsTemp = [];
    if (replacementOffers) {
      replacementOffers.forEach((x, i) => {
        replacementItemsTemp[i] = {
          itemCode: x.itemCode
        };
      });
    } else if (subscriptionItemInfo && isSubscriptionReplacementAllowed) {
      isFlavorReplacementAvailable.current = true;
      subscriptionItemInfo.filter(({
        productCode
      }) => productCode === itemCode).forEach(({
        replacements
      }) => replacements.forEach(({
        productCode
      }) => replacementItemsTemp.push({
        itemCode: String(productCode)
      })));
    }
    return replacementItemsTemp;
  }, [isSubscriptionReplacementAllowed, itemCode, replacementOffers, subscriptionItemInfo]);
  const replaceSubscription = (0, _react.useMemo)(() => {
    if (isFlavorReplacementAvailable.current && subscriptionId != null) {
      return {
        droppingId,
        subscriptionId
      };
    }
    return undefined;
  }, [droppingId, subscriptionId]);
  const canBeReplaced = (0, _react.useMemo)(() => replacementItems.length > 0, [replacementItems]);
  const replacementProductCodes = (0, _react.useMemo)(() => replacementItems.map(replacementItem => replacementItem.itemCode), [replacementItems]);
  const showProductInfoDialog = (0, _react.useCallback)((productCodes, originalItemCode) => {
    const customEvent = new CustomEvent(_openProductInfoDialog.Name, {
      detail: {
        atpClusterId,
        mode: _openProductInfoDialog.DialogMode.StandardBuy,
        lineNumber,
        ...(replaceSubscription ? {} : {
          originalQuantity: quantity
        }),
        originalItemCode,
        productCodes,
        // Subscription replacement (droppingId and subscriptionId) mode in PID, based on those 2 props
        replaceSubscription
      }
    });
    window.dispatchEvent(customEvent);
  }, [atpClusterId, lineNumber, quantity, replaceSubscription]);
  const onDialogChange = (0, _react.useCallback)(updatedItemLineNumber => {
    setChangedLineNumber(updatedItemLineNumber);
    if (handleChangedLineNumber) {
      handleChangedLineNumber(updatedItemLineNumber);
    }
  }, [handleChangedLineNumber, setChangedLineNumber]);

  // replace
  const showReplacementDialog = (0, _react.useCallback)(() => {
    showProductInfoDialog(replacementProductCodes, itemCode);
    onDialogChange(lineNumber);
  }, [itemCode, lineNumber, onDialogChange, replacementProductCodes, showProductInfoDialog]);

  // reserve
  const addBackorderDemand = (0, _react.useCallback)(() => {
    showProductInfoDialog([itemCode]);
    onDialogChange(lineNumber);
  }, [itemCode, lineNumber, onDialogChange, showProductInfoDialog]);
  return {
    canBeReplaced,
    addBackorderDemand,
    showReplacementDialog
  };
};
exports.useDialog = useDialog;